module.exports = __webpack_public_path__ + "media/images/featured-products/htt-e7050860e0b770f0b87c8aa604bc02aa.svg";